function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6.646-6.647a1.5 1.5 0 0 1 2.122 0l6.646 6.647a1 1 0 0 1-1.414 1.414L17 5.414V23a1 1 0 1 1-2 0V5.414zM1 19a1 1 0 1 1 2 0v8a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-8a1 1 0 1 1 2 0v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-8z"
});

var SvgUpload = function SvgUpload(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "efb16125830b36ccfc84a9282d762a76.svg";
export { SvgUpload as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/upload.svg
// module id = null
// module chunks = 